"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
var Role;
(function (Role) {
    Role["BI_ANALYST"] = "BI / Analyst";
    Role["BUSINESS_EXECUTIVE"] = "Business Executive";
    Role["CONSULTANT"] = "Consultant";
    Role["DATA_ENGINEER"] = "Data Engineer";
    Role["DATA_SCIENTIST"] = "Data Scientist";
    Role["DEVELOPER_ENGINEER"] = "Developer / Engineer";
    Role["IT_DBA"] = "IT / DBA";
    Role["PRODUCT_MANAGER"] = "Product Manager";
    Role["MARKETING"] = "Marketing";
    Role["SECURITY"] = "Security";
    Role["TECHNICAL_EXECUTIVE"] = "Technical Executive";
    Role["STARTTUP_FOUNDER"] = "Startup Founder";
    Role["STUDENT"] = "Student";
    Role["OTHER"] = "Other";
})(Role || (exports.Role = Role = {}));
//# sourceMappingURL=roles.js.map